import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { push } from "react-router-redux";
import { Button, Grid, Header, Responsive } from "semantic-ui-react";
import { mainIp } from "../../API/API";

const formatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
});

//formatter.format(sendingPrice).toString()

class DescripcionScreen extends React.Component {
  renderInDesktop() {
    let descImg = "";
    let file = "";

    if (this.props.descData.descriptionImage !== undefined) {
      descImg = mainIp + this.props.descData.descriptionImage.result;
    }
    if (this.props.descData.file !== undefined) {
      file = mainIp + this.props.descData.file.result;
    }

    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "stretch"
          }}
        >
          <div
            style={{
              width: "38%"
            }}
          >
            <div
              style={{
                backgroundImage: "url(" + descImg + ")",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                height: "100%"
              }}
            />
          </div>

          <div
            style={{
              width: "64vw",
              backgroundColor: "#023552",
              padding: "100px 100px 100px 127px",
              color: "white",
              fontFamily: "Lato",
              fontWeight: 300
            }}
          >
            <div
              style={{
                width: "34.5vw"
              }}
            >
              <Header
                style={{
                  fontFamily: "Merriweather",
                  fontWeight: "bold",
                  fontSize: "40px",
                  color: "#5aa7d1",
                  marginBottom: "40px"
                }}
              >
                Descripción
              </Header>
              <div
                style={{
                  fontSize: "18px",
                  lineHeight: "23px",
                  color: "white",
                  marginBottom: "24px"
                }}
                dangerouslySetInnerHTML={{
                  __html: this.props.descData.descriptionTop
                }}
              />
              <div
                style={{
                  lineHeight: "20px"
                }}
                dangerouslySetInnerHTML={{
                  __html: this.props.descData.descriptionBottom
                }}
              />
              <p
                style={{
                  fontWeight: "normal",
                  marginTop: "50px"
                }}
              >
                Especificaciones
              </p>
              <Header
                as="h2"
                style={{
                  color: "white",
                  marginBottom: 0
                }}
              >
                {formatter.format(this.props.descData.minPrice).toString()} a{" "}
                {formatter.format(this.props.descData.maxPrice).toString()}
              </Header>
              <p>RANGO DE PRECIOS DESDE:</p>
              <Grid columns={2}>
                <Grid.Column>
                  <Header
                    as="h2"
                    style={{
                      color: "white",
                      marginBottom: 0
                    }}
                  >
                    {this.props.descData.typeOfProperties}
                  </Header>
                  <p>TIPOS DE PROPIEDADES</p>
                </Grid.Column>
                <Grid.Column>
                  <Header
                    as="h2"
                    style={{
                      color: "white",
                      marginBottom: 0
                    }}
                  >
                    {this.props.descData.constructArea} m²
                  </Header>
                  <p>ÁREA DE DESARROLLO</p>
                </Grid.Column>
              </Grid>
              <Grid columns={2}>
                <Grid.Column width={8}>
                  <Button
                    onClick={() => {
                      let query = {
                        catalog: file
                      };
                      this.props.push({
                        pathname: window.location.pathname,
                        state: query
                      });
                      window.scroll({
                        top: document.getElementById("contact").offsetTop,
                        behavior: "smooth"
                      });
                    }}
                    target="_blank"
                    className="DButton"
                  >
                    IMPRIMIR DESARROLLO
                  </Button>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Button
                    href={this.props.descData.mapLocation}
                    target="_blank"
                    className="DButton"
                  >
                    VER EN MAPAS DE GOOGLE
                  </Button>
                </Grid.Column>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInTablet() {
    let descImg = "";
    let file = "";
    if (this.props.descData.descriptionImage !== undefined) {
      descImg = mainIp + this.props.descData.descriptionImage.result;
    }
    if (this.props.descData.file !== undefined) {
      file = mainIp + this.props.descData.file.result;
    }
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              width: "100%"
            }}
          >
            <div
              style={{
                backgroundImage: "url(" + descImg + ")",
                backgroundSize: "cover",
                position: "relative",
                height: "100%"
              }}
            />
          </div>

          <div
            style={{
              width: "1OO%",
              backgroundColor: "#023552",
              padding: "80px 10px 30px",
              color: "white",
              fontFamily: "Lato",
              fontWeight: 300
            }}
          >
            <Header
              style={{
                fontFamily: "Merriweather",
                fontWeight: "bold",
                fontSize: "1.7rem",
                color: "#5aa7d1",
                marginBottom: "4rem",
                textAlign: "center"
              }}
            >
              Descripción
            </Header>
            <div
              style={{
                fontSize: "18px",
                lineHeight: "23px",
                color: "white",
                marginBottom: "24px"
              }}
              dangerouslySetInnerHTML={{
                __html: this.props.descData.descriptionTop
              }}
            />

            <div
              style={{
                lineHeight: "20px"
              }}
              dangerouslySetInnerHTML={{
                __html: this.props.descData.descriptionBottom
              }}
            />

            <p
              style={{
                fontWeight: "normal",
                marginTop: "5rem"
              }}
            >
              Especificaciones
            </p>
            <Header
              as="h2"
              style={{
                color: "white",
                marginBottom: 0,
                fontSize: "1.2rem"
              }}
            >
              {formatter.format(this.props.descData.minPrice).toString()} a{" "}
              {formatter.format(this.props.descData.maxPrice).toString()}
            </Header>
            <p>RANGO DE PRECIOS DESDE:</p>

            <Grid columns={2}>
              <Grid.Column>
                <Header
                  as="h2"
                  style={{
                    color: "white",
                    marginBottom: 0,
                    fontSize: "1.2rem"
                  }}
                >
                  {this.props.descData.typeOfProperties}
                </Header>
                <p>TIPOS DE PROPIEDADES</p>
              </Grid.Column>

              <Grid.Column>
                <Header
                  as="h2"
                  style={{
                    color: "white",
                    marginBottom: 0,
                    fontSize: "1.2rem"
                  }}
                >
                  {this.props.descData.constructArea} m²
                </Header>
                <p>ÁREA DE DESARROLLO</p>
              </Grid.Column>
            </Grid>
            <Grid style={{ margin: "2rem 0rem" }} columns={2}>
              <Grid.Column
                style={{ display: "flex", justifyContent: "center" }}
                width={8}
              >
                <Button
                  onClick={() => {
                    let query = {
                      catalog: file
                    };
                    this.props.push({
                      pathname: window.location.pathname,
                      state: query
                    });
                    window.scroll({
                      top: document.getElementById("contact").offsetTop,
                      behavior: "smooth"
                    });
                  }}
                  target="_blank"
                  className="DButton"
                >
                  IMPRIMIR DESARROLLO
                </Button>
              </Grid.Column>
              <Grid.Column
                style={{ display: "flex", justifyContent: "center" }}
                width={8}
              >
                <Button
                  href={this.props.descData.mapLocation}
                  target="_blank"
                  className="DButton"
                >
                  VER EN MAPAS DE GOOGLE
                </Button>
              </Grid.Column>
            </Grid>
          </div>
        </div>
      </div>
    );
  }

  renderInMobile() {
    let descImg = "";
    let file = "";
    if (this.props.descData.descriptionImage !== undefined) {
      descImg = mainIp + this.props.descData.descriptionImage.result;
    }
    if (this.props.descData.file !== undefined) {
      file = mainIp + this.props.descData.file.result;
    }
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              width: "100%"
            }}
          >
            <div
              style={{
                backgroundImage: "url(" + descImg + ")",
                backgroundSize: "cover",
                position: "relative",
                height: "100%"
              }}
            />
          </div>

          <div
            style={{
              width: "1OO%",
              backgroundColor: "#023552",
              padding: "40px 10px 20px",
              color: "white",
              fontFamily: "Lato",
              fontWeight: 300
            }}
          >
            <Header
              style={{
                fontFamily: "Merriweather",
                fontWeight: "bold",
                fontSize: "1.7rem",
                color: "#5aa7d1",
                marginTop: "15px",
                marginBottom: "15px",
                textAlign: "center"
              }}
            >
              Descripción
            </Header>
            <div
              style={{
                fontSize: "18px",
                lineHeight: "23px",
                color: "white",
                marginBottom: "24px"
              }}
              dangerouslySetInnerHTML={{
                __html: this.props.descData.descriptionTop
              }}
            />

            <div
              style={{
                lineHeight: "20px"
              }}
              dangerouslySetInnerHTML={{
                __html: this.props.descData.descriptionBottom
              }}
            />

            <p
              style={{
                fontWeight: "normal",
                marginTop: "50px"
              }}
            >
              Especificaciones
            </p>

            <Header
              as="h2"
              style={{
                color: "white",
                marginBottom: 0,
                fontSize: "1.2rem"
              }}
            >
              {formatter.format(this.props.descData.maxPrice).toString()} a{" "}
              {formatter.format(this.props.descData.maxPrice).toString()}
            </Header>
            <p>RANGO DE PRECIOS DESDE:</p>

            <Grid columns={1}>
              <Grid.Column>
                <Header
                  as="h2"
                  style={{
                    color: "white",
                    marginBottom: 0,
                    fontSize: "1.2rem"
                  }}
                >
                  {this.props.descData.typeOfProperties}
                </Header>
                <p>TIPOS DE PROPIEDADES</p>
              </Grid.Column>

              <Grid.Column>
                <Header
                  as="h2"
                  style={{
                    color: "white",
                    marginBottom: 0,
                    fontSize: "1.2rem"
                  }}
                >
                  {this.props.descData.constructArea} m²
                </Header>
                <p>ÁREA DE DESARROLLO</p>
              </Grid.Column>
            </Grid>

            <Grid stackable columns={2} centered>
              <Grid.Column centered textAlign="center">
                <div className="marginTop" />
                <Button
                  onClick={() => {
                    let query = {
                      catalog: file
                    };
                    this.props.push({
                      pathname: window.location.pathname,
                      state: query
                    });
                    window.scroll({
                      top: document.getElementById("contact").offsetTop,
                      behavior: "smooth"
                    });
                  }}
                  target="_blank"
                  className="DButton "
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto"
                  }}
                >
                  IMPRIMIR DESARROLLO
                </Button>
              </Grid.Column>
              <Grid.Column
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  href={this.props.descData.mapLocation}
                  target="_blank"
                  className="DButton"
                >
                  VER EN MAPAS DE GOOGLE
                </Button>
              </Grid.Column>
              <div className="fixMarginBottom" />
            </Grid>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(DescripcionScreen)
);
